<template>
    <!--Waiting List Dashboard-->
    <div class="waiting-list-dashboard">
        <div class="wlist-dashboard-container">
            <!--Heading title-->
            <h3>{{ $t("waitingListDashboard.title") }}</h3>
            <!--Dashboard content-->
            <div class="wlist-dashboard-content section-wrap">
                <router-link :to="{ path: '/app/waiting-list/dashboard/clients' }">
                    {{ $t("waitingListDashboard.currentWaitlist") }}
                </router-link>
                <router-link :to="{ path: '/app/waiting-list/dashboard/invite-clients' }">
                    {{ $t("waitingListDashboard.inviteClients") }} - <span> {{
                        $t("waitingListDashboard.inviteMessage") }}</span>
                </router-link>
                <router-link :to="{ path: '/app/waiting-list/dashboard/notifications' }">
                    {{ $t("waitingListDashboard.notifications") }} - <span>{{
                        $t("waitingListDashboard.notificationsMessage") }}</span>
                </router-link>
                <router-link :to="{ path: '/app/waiting-list/dashboard/transactions' }">
                    {{ $t("waitingListDashboard.transactions") }} - <span>{{
                        $t("waitingListDashboard.transactionsMessage") }}</span>
                </router-link>
                <router-link :to="{ path: '/app/waiting-list/dashboard/settings' }">
                    {{ $t("waitingListDashboard.settings") }} - <span>{{
                        $t("waitingListDashboard.settingsMessage") }}</span>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    data() {
        return {};
    },
    computed: {},
    mounted() { },
    components: {},
    methods: {},

};
</script>
